module.exports = __webpack_public_path__ + "img/dots_rub_2.cdebd15c.png";